import { Button, Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import { uploadArchivoHeliosLiquidacionesHandler } from '../../actions/liquidaciones/liquidaciones';
import { useDispatch } from 'react-redux';
import { CloudUploadSharp } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    datosFc: {
        flex: 1,
        marginTop: 15,
        marginLeft: theme.spacing(5),
    },
    button: {
        marginTop: 10,
    },
}));


export const LiquidacionesCargaHelios = () => {

    const dispatch = useDispatch();
    const classes = useStyles();

    const fileFormat = ".csv";

    const handleChangeFile = (e) => {
        dispatch(
            uploadArchivoHeliosLiquidacionesHandler(
                e.target.files[0]
            )
        );
        e.target.value = null;
    };

    return (
        <>
            <input
                style={{ display: "none" }}
                id="selectArchivoExcel"
                accept={fileFormat}
                type="file"
                onChange={handleChangeFile}
            />
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} sm={6} md={4}>
                    <Button
                        color="primary"
                        variant="contained"
                        className={classes.button}
                        startIcon={<CloudUploadSharp />}
                        onClick={() =>
                            document.querySelector(`#selectArchivoExcel`).click()
                        }
                    >
                        Subir archivo Helios
                    </Button>
                </Grid>
            </Grid>

        </>

    )
}
